"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _Icon = require("@gogame/ui/Icon");
var _IconButton = _interopRequireDefault(require("@gogame/ui/IconButton"));
var _ColumnsWidthContext = _interopRequireDefault(require("./ColumnsWidthContext"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AutosizeColumns = /*#__PURE__*/(0, _react.forwardRef)(function (_, ref) {
  var apiRef = (0, _xDataGridPro.useGridApiContext)();
  var _useContext = (0, _react.useContext)(_ColumnsWidthContext["default"]),
    canResetColumnsWidth = _useContext.canResetColumnsWidth,
    clearColumnsWidthStorage = _useContext.clearColumnsWidthStorage;
  var handleResetToDefaultWidth = function handleResetToDefaultWidth() {
    var _apiRef$current;
    var columnsLookup = (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 ? void 0 : _apiRef$current.state.columns.lookup;
    if (!columnsLookup) {
      return;
    }
    Object.keys(columnsLookup).forEach(function (column) {
      var _columnsLookup$column = columnsLookup[column],
        field = _columnsLookup$column.field,
        initialWidth = _columnsLookup$column.initialWidth;
      if (field && initialWidth) {
        apiRef.current.setColumnWidth(field, initialWidth);
      }
    });
    queueMicrotask(clearColumnsWidthStorage);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ResetWidthIcon, {}),
    tooltip: 'Reset to default width',
    onClick: handleResetToDefaultWidth,
    disabled: !canResetColumnsWidth,
    ref: ref
  });
});
AutosizeColumns.displayName = 'AutosizeColumns';
var _default = exports["default"] = AutosizeColumns;